import { useAppSelector } from "@/hooks/useAppSelector";
import { NPVRow, UPRow } from "@/types/types";
import { ColumnCellTemplateData } from "devextreme/ui/data_grid";
import RetirementAgeTooltip from "../UP/RetirementAgeTooltip";
import SetRetirementCtxMenu from "../UP/SetRetirementCtxMenu";
import { useHouseholdData } from "@/hooks/useHouseholdData";
import { HouseholdDataType } from "@/types/enums";

type Props = {
  data: ColumnCellTemplateData<UPRow | NPVRow>;
  clientExternalCode: string | undefined;
  isSecondary?: boolean;
  isNpv?: boolean;
};

const AgeCell = ({ data, clientExternalCode, isSecondary = false, isNpv = false }: Props) => {
  const {
    age1: age1Now,
    isAge1Incremented,
    isAge2Incremented,
    age2: age2Now,
  } = useAppSelector((state) => state.household);

  const { data: retirementAgeData } = useHouseholdData(
    clientExternalCode,
    HouseholdDataType.RetirementAge
  );
  const ageNow = isSecondary ? (age2Now ?? 0) : age1Now;
  const isContactOlderThan90 = (ageNow ?? 0) > 90;
  const age2Match = data.data?.Age2?.value === age2Now;
  const age1Match = data.data?.Age?.value === age1Now;

  const value = data.value?.value ?? 0;

  if (value > 110 || (!isContactOlderThan90 && value > 100) || value < 0) return "";

  const isRetirementAge = Number(retirementAgeData?.data.data) === value;
  const showIncrementedStyle =
    isSecondary && age2Match ? isAge2Incremented : age1Match ? isAge1Incremented : false;

  return (
    <div
      id={`${isSecondary}-${data.rowIndex}-${showIncrementedStyle}`}
      className={`relative px-2 py-[14px] text-sm print:px-1 print:py-1 print:!text-[10px] ${
        isRetirementAge ? "font-medium italic" : ""
      } ${showIncrementedStyle ? "bg-tertiary" : ""}`}
    >
      {value}
      {!isNpv && (
        <SetRetirementCtxMenu
          clientId={clientExternalCode}
          retirementAge={Number(retirementAgeData?.data?.data ?? 0)}
          rowAge={value}
          target={`#${isSecondary}-${data.rowIndex}-${showIncrementedStyle}`}
        />
      )}

      {isRetirementAge ? (
        <RetirementAgeTooltip id={`${isSecondary}-${data.rowIndex}-${showIncrementedStyle}`} />
      ) : null}
    </div>
  );
};

export default AgeCell;
